import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function SEOSchema() {
  const location = useLocation();
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useEffect(() => {
    // Remove existing schema scripts
    const existingScripts = document.querySelectorAll('script[type="application/ld+json"]');
    existingScripts.forEach(script => script.remove());

    let schemaData: any = null;

    // Home page schema
    if (location.pathname === '/' || location.pathname === '') {
      schemaData = {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "ProfessionalService",
            "@id": `${siteUrl}/#organization`,
            "name": "KIMURAMA WORKS",
            "description": "業務設計から定着支援まで、実務に根ざしたAI導入を支援する伴走型AIコンサルティングサービス",
            "url": siteUrl,
            "founder": {
              "@type": "Person",
              "name": "木村ま誇",
              "jobTitle": "AIクリエイター・AIライター・AIコンサルタント",
              "email": "km.works.aidesign@gmail.com"
            },
            "areaServed": "JP",
            "serviceType": ["AIコンサルティング", "AIライティング", "SNSコンテンツ支援", "プロンプト設計", "チャットボット構築", "業務効率化支援"]
          },
          {
            "@type": "WebSite",
            "@id": `${siteUrl}/#website`,
            "url": siteUrl,
            "name": "KIMURAMA WORKS",
            "description": "伴走型AIコンサルティングサービス",
            "publisher": {
              "@id": `${siteUrl}/#organization`
            }
          },
          {
            "@type": "WebPage",
            "@id": `${siteUrl}/#webpage`,
            "url": siteUrl,
            "name": "KIMURAMA WORKS | AIコンサルティング・AIライター・AI人材育成",
            "isPartOf": {
              "@id": `${siteUrl}/#website`
            },
            "about": {
              "@id": `${siteUrl}/#organization`
            },
            "description": "KIMURAMA WORKS（木村ま誇）は、業務設計から定着支援まで実務に根ざしたAI導入を支援する伴走型AIコンサルティングサービスです。"
          }
        ]
      };
    }

    // Add schema to head
    if (schemaData) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schemaData);
      document.head.appendChild(script);
    }
  }, [location.pathname, siteUrl]);

  return null;
}
